const formatTimeText = (value: string): string => {
  // 1000 -> 10:00
  if (value.match(/^[0-9]{2}[0-9]{2,}/))
    return `${value.slice(0, 2)}:${value.slice(2)}`;
  // 500 -> 5:00
  if (value.match(/^[0-9][0-9]{2,}/)) return `${value[0]}:${value.slice(1)}`;
  // 10:0 -> 1:00
  if (value.match(/^[0-9]{2}:[0-9]$/))
    return `${value[0]}:${value[1]}${value.slice(3)}`;
  // 1:030 -> 10:30
  if (value.match(/^[0-9]:[0-9]{3}/))
    return `${value[0]}${value[2]}:${value.slice(3)}`;

  return value;
};

export default formatTimeText;
